__turbopack_context__.v({
  "alignLeft": "ExclusiveOffers-module__3BH6Za__alignLeft",
  "badge": "ExclusiveOffers-module__3BH6Za__badge",
  "badgeSlot": "ExclusiveOffers-module__3BH6Za__badgeSlot",
  "card": "ExclusiveOffers-module__3BH6Za__card",
  "cardBody": "ExclusiveOffers-module__3BH6Za__cardBody",
  "cardDesc": "ExclusiveOffers-module__3BH6Za__cardDesc",
  "cardLink": "ExclusiveOffers-module__3BH6Za__cardLink",
  "cardTitle": "ExclusiveOffers-module__3BH6Za__cardTitle",
  "carouselDots": "ExclusiveOffers-module__3BH6Za__carouselDots",
  "codeBox": "ExclusiveOffers-module__3BH6Za__codeBox",
  "codeLabel": "ExclusiveOffers-module__3BH6Za__codeLabel",
  "codePrefix": "ExclusiveOffers-module__3BH6Za__codePrefix",
  "codePrefixMob": "ExclusiveOffers-module__3BH6Za__codePrefixMob",
  "header": "ExclusiveOffers-module__3BH6Za__header",
  "section": "ExclusiveOffers-module__3BH6Za__section",
  "slickSlide": "ExclusiveOffers-module__3BH6Za__slickSlide",
  "slickWrap": "ExclusiveOffers-module__3BH6Za__slickWrap",
  "slickWrapMobile": "ExclusiveOffers-module__3BH6Za__slickWrapMobile",
  "sliderFallback": "ExclusiveOffers-module__3BH6Za__sliderFallback",
  "tab": "ExclusiveOffers-module__3BH6Za__tab",
  "tabActive": "ExclusiveOffers-module__3BH6Za__tabActive",
  "tabLabelDesktop": "ExclusiveOffers-module__3BH6Za__tabLabelDesktop",
  "tabLabelMobile": "ExclusiveOffers-module__3BH6Za__tabLabelMobile",
  "tabs": "ExclusiveOffers-module__3BH6Za__tabs",
  "tabsShell": "ExclusiveOffers-module__3BH6Za__tabsShell",
  "viewAll": "ExclusiveOffers-module__3BH6Za__viewAll",
  "viewAllDesktop": "ExclusiveOffers-module__3BH6Za__viewAllDesktop",
});
